module.exports = __webpack_public_path__ + "static/img/rs_bg.fe3fd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/rs_bg.png
// module id = sbEs
// module chunks = 1